import { storeInfo } from "@/api/user";
import { restockStore } from "@/@types/restock";
import { GetWarehouseList, GetShippingType, WarehouseList, ShippingType, GetSellerCountry, GetAdminCountry } from "@/api/Kilimall/restockPlan";
import { GetMapsList } from "@/api/Kilimall/replenishment";
import store from '@/store'
// 公共方法


/**
 * 获取店铺信息,并更新本地数据
 */
const updateStoreInfo = () => {
    storeInfo().then((ret: any) => {
        if (ret.code === 200) {
            store.dispatch("setStoreInfo", ret.data);
        }
    });
}

// 获取计划备货的仓库列表
const getWarehouseList = async (isAdmin: boolean = false, regionCode?: string) => {
    const warehouseFn = isAdmin ? WarehouseList() : GetWarehouseList(regionCode)
    const res: any = await warehouseFn;
    if(isAdmin){
      if (res.code === 0) {
        store.dispatch("setWarehouse", res.data);
        return res.data
    }
    }else {
      if (res.code === 200) {
        store.dispatch("setWarehouse", res.data);
        return res.data
      }
    }
    return null

};
/** 获取计划备货的发货方式  */
const getShippingType = async (isAdmin: boolean = false) => {
    const shippingFn = isAdmin ? ShippingType() : GetShippingType()
    const res: any = await shippingFn;
    if (res.code === 0) {
        const newArr = []
        Object.keys(res.data).forEach((item: any) => {
            newArr.push({ name: res.data[item], code: Number(item) });
        });
        store.dispatch("setShipping", newArr);
        return newArr
    }
    return null
};
/** 获取计划备货邀请渠道数据  */
const getMaps = async () => {
    const shippingFn = GetMapsList()
    const res: any = await shippingFn;
    if (res.code === 0) {
        const newArr = []
        store.dispatch("setMaps", res.data);
        return newArr
    }
    return null
};
/** 邀请备货计划中国家列表的获取  */
const getRegionList = async (isAdmin) => {
    const shippingFn = isAdmin ? GetAdminCountry() : GetSellerCountry()
    const res: any = await shippingFn;
    if (res.code === 0) {
        const newArr = []
        const data = isAdmin ? res.data.localizedSubsidiaries : res.data
        store.dispatch("setRegionList", data);
        return newArr
    }
    return null
};
/**获取计划备货的仓库或者发运方式数据/邀请渠道 国家*/
const setApplyCondition = (type: string | Array<string>, isAdmin?: boolean, regionCode?: string) => {
    return new Promise(async (resolve, reject) => {
        // type 可以为all,warehouse,shipping
        const warehouse = JSON.parse(
            localStorage.getItem(restockStore.restock_warehouse)
        );
        const shipping = JSON.parse(
            localStorage.getItem(restockStore.restock_shipping)
        );
        const mapsList = JSON.parse(
            localStorage.getItem(restockStore.restock_maps)
        );
        const regionList = JSON.parse(
            localStorage.getItem(restockStore.region_list)
        );
        let resData = { warehouse, shipping, mapsList, regionList }
        let isRequest = false

        /** 1. 仓库列表/发货方式/其他的maps(channel等)无数据重新请求,有数据从缓存中获取数据
         *  2. 传入 string 类型,获取单个的数据("warehouse")或全部数据("all")
         *  3. 传入数组时,分为两种情况:
         *       3.1 不管有无数据时都能重新获取数据,则要传入一个数组,列入想要获取仓库列表 ['getWarehouse']
         *       3.2 同时获取其中的两个或多个 如: ["warehouse","maps"]
         */
        if ((!warehouse?.length && (type === 'warehouse' || type.includes("warehouse") || type === 'all')) || type.includes("getWarehouse")) {
            resData.warehouse = await getWarehouseList(isAdmin, regionCode)
            isRequest = true
        }
        if ((!shipping?.length && (type === 'shipping' || type.includes("shipping") || type === 'all')) || type.includes("getShipping")) {
            resData.shipping = await getShippingType(isAdmin);
            isRequest = true
        }
        if ((!mapsList && (type === 'maps'|| type.includes("maps")))  || type.includes("getMaps")) {
            resData.mapsList = await getMaps();
            isRequest = true
        }
        if ((!regionList && (type === 'region'|| type.includes("region")))  || type.includes("getRegion")) {
            resData.mapsList = await getRegionList(isAdmin);
            console.log(555);

            isRequest = true
        }
        !isRequest || resData.warehouse || resData.shipping || resData.mapsList || resData.regionList  ? resolve(resData) : reject()
    })

};

/** 处理请求参数 未包含在notInclude 中的数据才可保留 参数进行传递*/
const setParamsObj =(obj,notInclude = ['', null, undefined]) => {
    if (!obj) {
        return
    }
    const newObj = {}
    Object.keys(obj).forEach((item) => {
        const _c = obj[item]
        if (!notInclude.includes(_c)) {
          newObj[item] = _c
        }
    })
    return newObj
}

const getVideoCover = (videoUrl) => {
    return new Promise(resolve => {
      let dataURL = ''
      const video:any = document.createElement('video')
      video.crossOrigin = 'anonymous' // 处理跨域
      video.src = videoUrl
      video.type = 'video/mp4'
      video.currentTime = 3 // 第3帧
      video.onloadeddata = () => {
        const canvas = document.createElement('canvas')
        const size = 80
        canvas.width = size
        canvas.height = size
        canvas.getContext('2d').drawImage(video, 0, 0, size, size) // 绘制canvas
        dataURL = canvas.toDataURL('image/jpeg') // 转换为base64
        resolve(dataURL)
      }
    })
  }
export {
    updateStoreInfo,
    getWarehouseList,
    getShippingType,
    setApplyCondition,
    setParamsObj,
    getVideoCover
}
